import { render, staticRenderFns } from "./djgbpk.vue?vue&type=template&id=21c40630&scoped=true&"
import script from "./djgbpk.vue?vue&type=script&lang=js&"
export * from "./djgbpk.vue?vue&type=script&lang=js&"
import style0 from "./djgbpk.vue?vue&type=style&index=0&id=21c40630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c40630",
  null
  
)

export default component.exports